import { isDefined } from './is-defined.guard';

/**
 * Type guard that checks if a value is `null` or `undefined`.
 *
 * Optionally, if `checkProperties` is `true` and property keys are provided,
 * it will check if any of the specified properties on the value are not defined.
 *
 * @typeParam T - The type of the value to check.
 * @param value - The value to check for being not defined.
 * @param checkProperties - Whether to check specific properties for being not defined.
 * @param properties - The property keys to check on the value if `checkProperties` is `true`.
 * @returns `true` if the value is `null` or `undefined`,
 * or if any specified property is not defined; otherwise, `false`.
 */
export const isNotDefined = <T = unknown>(
  value: T | null | undefined,
  checkProperties = false,
  ...properties: (keyof T)[]
): value is null | undefined => {
  return !isDefined(value, checkProperties, ...properties);
};
